const PAYMENT_LINKS_MODALS = {
  DELETE: 'delete-payment-link',
  CREATE: 'create-payment-link',
  SUCCESS: 'payment-successfully-created',
  QR_CODE: 'qr-code-modal'
};

export { PAYMENT_LINKS_MODALS };
